module.exports = __webpack_public_path__ + "static/img/7.b43f39f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hellohr/7.png
// module id = QYQv
// module chunks = 0